
export type StorageType = number;
export let StorageType: any = {};
StorageType.MEMORY = 0;
StorageType.IMMUTABLE_MEMORY = 1;
StorageType.SESSION = 2;
StorageType.LOCAL = 3;
StorageType[StorageType.MEMORY] = "MEMORY";
StorageType[StorageType.IMMUTABLE_MEMORY] = "IMMUTABLE_MEMORY";
StorageType[StorageType.SESSION] = "SESSION";
StorageType[StorageType.LOCAL] = "LOCAL";


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
